{
    "name": "@slashid/slashid",
    "private": false,
    "publishConfig": {
        "access": "public"
    },
    "version": "3.30.0",
    "description": "Client SDK for the /id platform",
    "homepage": "https://slashid.com",
    "author": "SlashID",
    "license": "MIT",
    "main": "./dist/bundle/slashid.js",
    "module": "./dist/esmodule/slashid.esm.js",
    "esmodule": "./dist/esmodule/slashid.esm.js",
    "commonjs": "./dist/commonjs/slashid.cjs.js",
    "bundle": "./dist/bundle/slashid.js",
    "types": "./dist/types/slashid.d.ts",
    "exports": {
        ".": {
            "require": "./dist/commonjs/slashid.cjs.js",
            "import": "./dist/esmodule/slashid.esm.js",
            "default": "./dist/commonjs/slashid.cjs.js",
            "types": "./dist/types/slashid.d.ts"
        }
    },
    "targets": {
        "esmodule": {
            "source": "src/targets/package.ts",
            "context": "browser",
            "isLibrary": true,
            "outputFormat": "esmodule",
            "engines": {
                "browsers": [
                    "and_chr >= 73",
                    "chrome >= 73",
                    "and_ff >= 67",
                    "android >= 114",
                    "edge >= 79",
                    "samsung >= 11.2",
                    "safari >= 13",
                    "ios_saf >= 13.1",
                    "opera >= 60",
                    "firefox >= 67",
                    "unreleased and_chr versions",
                    "unreleased chrome versions",
                    "unreleased and_ff versions",
                    "unreleased android versions",
                    "unreleased edge versions",
                    "unreleased samsung versions",
                    "unreleased safari versions",
                    "unreleased ios_saf versions",
                    "unreleased opera versions",
                    "unreleased firefox versions"
                ]
            }
        },
        "commonjs": {
            "source": "src/targets/package.ts",
            "context": "node",
            "isLibrary": true,
            "outputFormat": "commonjs",
            "engines": {
                "node": ">= 12"
            }
        },
        "bundle": {
            "source": "src/targets/bundle.ts",
            "context": "browser",
            "outputFormat": "global",
            "engines": {
                "browsers": [
                    "> 0.5%",
                    "last 2 versions",
                    "not dead"
                ]
            }
        },
        "page": {
            "source": "static/sdk.html",
            "context": "browser",
            "engines": {
                "browsers": [
                    "and_chr >= 73",
                    "chrome >= 73",
                    "and_ff >= 67",
                    "android >= 114",
                    "edge >= 79",
                    "samsung >= 11.2",
                    "safari >= 13",
                    "ios_saf >= 13.1",
                    "opera >= 60",
                    "firefox >= 67",
                    "unreleased and_chr versions",
                    "unreleased chrome versions",
                    "unreleased and_ff versions",
                    "unreleased android versions",
                    "unreleased edge versions",
                    "unreleased samsung versions",
                    "unreleased safari versions",
                    "unreleased ios_saf versions",
                    "unreleased opera versions",
                    "unreleased firefox versions"
                ]
            }
        },
        "types": {
            "source": "src/targets/package.ts"
        }
    },
    "files": [
        "dist/*"
    ],
    "keywords": [
        "slashid",
        "SlashID",
        "auth",
        "openid",
        "authentication",
        "jwt",
        "browser"
    ],
    "scripts": {
        "clean": "rm -rf dist docs",
        "lint": "eslint ./src --ext .ts",
        "format": "prettier --config .prettierrc.json 'src/**/*.ts' --write",
        "test:ts": "tsc --project tsconfig.json --noEmit",
        "test:unit": "jest",
        "test:unit:watch": "jest --watch",
        "test:unit:ci": "jest --ci",
        "test:integration": "playwright test",
        "build": "rm -rf dist && parcel build --no-cache && cp compat/esmodule/package.json dist/esmodule",
        "docs": "rm -rf docs && typedoc",
        "dist": "npm run lint && npm run build",
        "all": "npm run dist && npm run docs",
        "serve:all": "parcel serve 'static/*.html' --port 8080 --no-cache",
        "serve:example": "parcel serve static/index.html --port 8080 --no-cache",
        "serve:jump": "parcel serve static/sdk.html --port 8080 --no-cache",
        "serve:docs": "parcel serve docs/index.html --port 8081 --no-cache",
        "push:docs": "aws s3 sync docs s3://slashiddoc/sdk/v$(node tools/version.js --major) && (aws cloudfront create-invalidation --distribution-id ETLBNGAAF97EN --paths \"/*\")",
        "changeset": "changeset",
        "prepublishOnly": "npm run all",
        "publish:ci": "npm run build && changeset publish"
    },
    "devDependencies": {
        "@changesets/cli": "^2.29.8",
        "@parcel/core": "2.16.4",
        "@parcel/packager-ts": "2.16.4",
        "@parcel/resolver-default": "2.16.4",
        "@parcel/transformer-babel": "2.16.4",
        "@parcel/transformer-js": "2.16.4",
        "@parcel/transformer-json": "2.16.4",
        "@parcel/transformer-react-refresh-wrap": "2.16.4",
        "@parcel/transformer-typescript-types": "2.16.4",
        "@playwright/test": "1.62.1",
        "@types/jest": "^28.1.7",
        "@types/node": "~24.13.0",
        "@types/qrcode": "^1.5.0",
        "@types/ua-parser-js": "^0.7.39",
        "@typescript-eslint/eslint-plugin": "^4.15.1",
        "@typescript-eslint/parser": "^4.15.1",
        "danger": "^13.0.7",
        "eslint": "^7.20.0",
        "eslint-config-prettier": "^8.5.0",
        "eslint-plugin-prettier": "^4.2.1",
        "https-proxy-agent": "^7.0.5",
        "isomorphic-fetch": "^3.0.0",
        "jest": "^28.1.3",
        "jest-environment-jsdom": "^28.1.3",
        "jest-fetch-mock": "^3.0.3",
        "parcel": "2.16.4",
        "prettier": "^2.7.1",
        "ts-jest": "^28.0.8",
        "typedoc": "^0.23.00",
        "typedoc-plugin-mdn-links": "^2.0.0",
        "typedoc-plugin-missing-exports": "^1.0.0",
        "typescript": "~4.9.5"
    },
    "dependencies": {
        "compare-versions": "^6.1.0",
        "docdash": "^2.0.2",
        "jwt-decode": "^3.1.2",
        "qrcode": "^1.5.1",
        "querystring-es3": "^0.2.1",
        "regenerator-runtime": "^0.14.1",
        "ua-parser-js": "^1.0.37",
        "url": "^0.11.0",
        "uuid": "^11.1.1"
    },
    "resolutions": {
        "@babel/runtime": "7.26.10",
        "@babel/helpers": "7.26.10",
        "jest-environment-jsdom/**/form-data": "4.0.6",
        "brace-expansion": "^2.1.3",
        "cross-spawn": ">=7.0.5",
        "js-yaml": "^4.3.0",
        "qs": ">=6.14.1",
        "undici": ">=6.27.0 <7",
        "fast-uri": ">=3.1.4 <4"
    }
}
